import React, { useEffect, useState } from "react";
import { TbUserSearch } from "react-icons/tb";
import { useLocation, useNavigate } from "react-router-dom";
import { CONSTANTS } from "src/constants";
import { URL_CONSTANTS } from "src/constants/url.constants";
import { useAuth } from "src/context/userContext";
import { SidebarItem } from "src/models/common.model";

import CIcon from "@coreui/icons-react";
import {
  CNavGroup,
  CNavItem,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
} from "@coreui/react";

import { COMMON_CONSTANTS } from "../../../constants/commonConstants";
import { MODAL_TEXT_CONSTANTS } from "../../../constants/navbarConstants";
import { SIDEBAR_CONSTANTS } from "../../../constants/sidebarConstants";
import { SideBarProps } from "../../../models/layout.models";
import commonUtils from "../../../utils/common.utils";
import ConfirmModal from "../ConfirmModal/ConfirmModal";

const Sidebar: React.FC<SideBarProps> = ({
  isOpen = CONSTANTS.COMMON_CONSTANTS.OPEN,
  className,
  sidebarItems,
}) => {
  const { pathname } = useLocation();
  const path = pathname.split("/");
  const label = path[2];

  const [activeItem, setActiveItem] = useState(label);

  const [showModal, setShowModal] = useState(CONSTANTS.COMMON_CONSTANTS.HIDE);

  const { logout }: { logout?: () => void } = useAuth() || {};

  useEffect(() => {
    if (label) setActiveItem(label);
  }, [label]);

  const handleCancelLogout = () => {
    setShowModal(CONSTANTS.COMMON_CONSTANTS.HIDE);
  };

  const handleConfirmLogout = () => {
    commonUtils.toastService(COMMON_CONSTANTS.LOGOUT_MESSAGE);
    logout && logout();
    setShowModal(CONSTANTS.COMMON_CONSTANTS.HIDE);
  };

  const handleLogout = () => {
    setShowModal(CONSTANTS.COMMON_CONSTANTS.SHOW);
  };

  const navigate = useNavigate();

  const handleOnClick = (item: SidebarItem): void => {
    if (item.action.type === SIDEBAR_CONSTANTS.ACTIONS.LOGOUT) {
      handleLogout();
    } else if (item.action.route) {
      navigate(item.action.route);
      setActiveItem(item.action.route);
    }
  };

  return (
    <CSidebar
      className={`dd-sidebar ${className}`}
      position="fixed"
      visible={isOpen}
    >
      <CSidebarBrand className="justify-content-start">
        <a
          className="dd-sidebar-logo"
          href={URL_CONSTANTS.ADMIN_DASHBOARD}
          onClick={e => {
            e.preventDefault();
            navigate(SIDEBAR_CONSTANTS.ROUTE_DASHBOARD);
            setActiveItem(SIDEBAR_CONSTANTS.ROUTE_DASHBOARD);
          }}
          onKeyDown={e => {
            if (e.key === COMMON_CONSTANTS.KEYWORD) {
              e.preventDefault();
              navigate(SIDEBAR_CONSTANTS.ROUTE_DASHBOARD);
              setActiveItem(SIDEBAR_CONSTANTS.ROUTE_DASHBOARD);
            }
          }}
        >
          <img
            className="dd-logo-header mx-3"
            src={COMMON_CONSTANTS.SIDEBAR_LOGO}
            alt="Dental Dynamic Staffing"
          />
        </a>
      </CSidebarBrand>

      <CSidebarNav className="right-side-scroll">
        {sidebarItems?.map(item => {
          if (item.children && item.children.length > 0) {
            return (
              <CNavGroup
                key={item.label}
                toggler={
                  <>
                    <CIcon customClassName="nav-icon" icon={item.icon} />{" "}
                    {item.label}
                  </>
                }
              >
                {item.children.map(child => (
                  <CNavItem
                    key={child.label}
                    href={child.action.route ?? "#"}
                    active={
                      child.action.route === activeItem ||
                      child.action.route?.split("/").pop() === activeItem
                    }
                    onClick={e => {
                      e.preventDefault();
                      handleOnClick(child);
                    }}
                  >
                    {child.icon && (
                      <CIcon customClassName="nav-icon" icon={child.icon} />
                    )}
                    {child.label}
                  </CNavItem>
                ))}
              </CNavGroup>
            );
          }

          return (
            <CNavItem
              key={item.label}
              href={item.action.route ?? "#"}
              active={
                item.action.route === activeItem ||
                item.action.route?.split("/").pop() === activeItem ||
                item.action.route?.includes(activeItem)
              }
              onClick={e => {
                e.preventDefault();
                handleOnClick(item);
              }}
            >
              {item.moduleId === SIDEBAR_CONSTANTS.MODULE_ID.PROSPECTS ? (
                <TbUserSearch className="nav-icon" />
              ) : (
                <CIcon customClassName="nav-icon" icon={item.icon} />
              )}
              {item.label}
            </CNavItem>
          );
        })}
      </CSidebarNav>
      <ConfirmModal
        title={MODAL_TEXT_CONSTANTS.MODAL_LOGOUT}
        confirmButtonText={MODAL_TEXT_CONSTANTS.CONFIRM_BUTTON}
        cancelButtonText={MODAL_TEXT_CONSTANTS.CANCEL_BUTTON}
        onConfirm={handleConfirmLogout}
        onCancel={handleCancelLogout}
        isShow={showModal}
      />
    </CSidebar>
  );
};

export default Sidebar;
